import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    getDataTaskList: "api/v1/events/tasks",
    eventList: "api/v1/events",
    taskConnection: "api/v1/events/tasks/connections",
}

export const getDataTaskList = (params: types.ITaskListParams) => {
    let taskParams = params.taskCode && params.taskType ? apiUrls.getDataTaskList + "?taskType=" + params.taskType + "&taskCode=" + params.taskCode
        : !params.taskCode && params.taskType ? apiUrls.getDataTaskList + "?taskType=" + params.taskType : apiUrls.getDataTaskList
    return Api.get<types.IDataTask[]>(taskParams);
}

export const getLoaderList = (params: types.ILoaderListParams) => {
    let taskParams = params.taskCode && params.taskType ? apiUrls.getDataTaskList + "?taskType=" + params.taskType + "&taskCode=" + params.taskCode
        : !params.taskCode && params.taskType ? apiUrls.getDataTaskList + "?taskType=" + params.taskType : apiUrls.getDataTaskList
    return Api.get<types.IDataLoader[]>(taskParams);
}


export const getDataEventTaskList = (params: types.IEventTaskListParams) => {
    let taskParams = params.taskCode ? apiUrls.getDataTaskList + "?taskType=" + params.taskType + "&taskCode=" + params.taskCode
        : params.taskConnectionId ? apiUrls.getDataTaskList + "?taskConnectionId=" + params.taskConnectionId 
          : apiUrls.getDataTaskList + "?taskType=" + params.taskType
    return Api.get<types.IDataEventTask[]>(taskParams);
}


export const getEventList = (params: types.IEventListParams) => {
    let eventParams = params.eventActionValue ? apiUrls.eventList + "?eventActionValue=" + params.eventActionValue
        : apiUrls.eventList + "?taskType=" + params.eventType
    return Api.get<types.IEvent[]>(eventParams);
}

export const getInboundList = (params: types.IInboundListParams) => {
    let eventParams = apiUrls.eventList + "?eventType=" + params.eventType + "&eventActionValue=" + params.eventActionValue
    return Api.get<types.IInboundEvent[]>(eventParams);
}

export const getOutboundList = (params: types.IOutboundListParams) => {
    let eventParams = apiUrls.eventList + "?eventAction=" + params.eventAction + "&eventQualifier=" + params.eventQualifier
    return Api.get<types.IInboundEvent[]>(eventParams);
}

export const postTask = (payload: types.IPostTaskParams) =>
    Api.post(apiUrls.getDataTaskList, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const editTask = (param: string, payload: types.IPutTaskParams) =>
    Api.put(apiUrls.getDataTaskList + `/${param}`, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });


export const getTaskConnection = (params: types.ITaskConnectionParams) => {
    let connectionParams = apiUrls.taskConnection + "?layerName=" + params.layerName 
    return Api.get<types.ITaskConnection[]>(connectionParams);
}

export const postTaskConnection = (payload: types.newTaskConnection) =>
    Api.post(apiUrls.taskConnection, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });


